// extracted by mini-css-extract-plugin
export var cls1 = "CorcheaCortaSvg-module--cls-1--pZj3x";